/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsAttributionMutationData
 */
export interface GoogleAnalyticsAttributionMutationData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionMutationData
     */
    revisionId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionMutationData
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionMutationData
     */
    reason?: string;
}

/**
 * Check if a given object implements the GoogleAnalyticsAttributionMutationData interface.
 */
export function instanceOfGoogleAnalyticsAttributionMutationData(value: object): value is GoogleAnalyticsAttributionMutationData {
    return true;
}

export function GoogleAnalyticsAttributionMutationDataFromJSON(json: any): GoogleAnalyticsAttributionMutationData {
    return GoogleAnalyticsAttributionMutationDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionMutationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAttributionMutationData {
    if (json == null) {
        return json;
    }
    return {
        
        'revisionId': json['revisionId'] == null ? undefined : json['revisionId'],
        'status': json['status'] == null ? undefined : json['status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function GoogleAnalyticsAttributionMutationDataToJSON(json: any): GoogleAnalyticsAttributionMutationData {
    return GoogleAnalyticsAttributionMutationDataToJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionMutationDataToJSONTyped(value?: GoogleAnalyticsAttributionMutationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'revisionId': value['revisionId'],
        'status': value['status'],
        'reason': value['reason'],
    };
}

